module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('mt-cell-group', [_c('mt-picker-select', {
    attrs: {
      "label": "抄送人员",
      "rows": "5",
      "maxlength": "100",
      "options": _vm.singleSelectOptions
    },
    model: {
      value: (_vm.singleSelectValue),
      callback: function($$v) {
        _vm.singleSelectValue = $$v
      },
      expression: "singleSelectValue"
    }
  }), _vm._v(" "), _c('mt-picker-select', {
    attrs: {
      "label": "只读的",
      "placeholder": "请选择",
      "rows": "5",
      "maxlength": "100",
      "readonly": "",
      "options": _vm.singleSelectOptions
    },
    model: {
      value: (_vm.singleSelectValue1),
      callback: function($$v) {
        _vm.singleSelectValue1 = $$v
      },
      expression: "singleSelectValue1"
    }
  }), _vm._v(" "), _c('mt-picker-select', {
    attrs: {
      "label": "禁用的",
      "placeholder": "请选择",
      "rows": "5",
      "maxlength": "100",
      "disabled": "",
      "options": _vm.singleSelectOptions
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327e69d0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/picker-select.vue
// module id = 579
// module chunks = 0